import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const ctaSchema = {
    componentId: "Cta",
    scalarSlots: [
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Heading", type: "text" },
        {
            key: "body",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Body",
            type: "textarea",
        },
        {
            key: "emailCapture",
            label: "Show email capture instead of button",
            type: "boolean",
        },
        { key: "ctaLabel", label: "Button label", type: "text" },
        { key: "ctaHref", label: "Button link", type: "url" },
        { key: "submitLabel", label: "Email submit label", type: "text" },
        { key: "placeholder", label: "Email placeholder", type: "text" },
    ],
    mediaSlots: [],
};
//# sourceMappingURL=cta.js.map